import { DashboardService } from './../dashboard.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BarCodeValidate } from '../../../shared/bar-code-validate';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { PaymentSecuritiesEventType } from '../../payment-securities/payment-securities.event.type';


@Component({
	selector: 'app-bar-code',
	templateUrl: './bar-code.component.html',
	styleUrls: ['./bar-code.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BarCodeComponent implements OnInit {
	barCodeError: boolean;
	submited: boolean;

	public form: FormGroup;

	barCode = '';
	barCodeOld = '';

	constructor(private router: Router, private formBuilder: FormBuilder, private dashboardService: DashboardService) {
		this.form = formBuilder.group({
			barCode: [null, Validators.required]
		});
	}

	ngOnInit() {
	}

	sendToPaymentSection() {
		this.submited = true;

		if (this.form.valid) {
			this.submited = false;

			this.dashboardService.changeMessage(this.form.controls.barCode.value);

			this.router.navigate(['/pagamentos/contas/']);
		}
	}

	maskBarCode(event) {
		const p = event.target.value;
		const firstStringSecuritie = p.substring(0, 1);

		if ( firstStringSecuritie !== '8' ) {
			let a = p.replace(/\D/g, '').substring(0, /^8/.test(p) ? 48 : 47);
			a = a
				.replace(
					/(\d{0,5})(\d{0,5})(\d{0,5})(\d{0,6})(\d{0,5})(\d{0,6})(\d{0,1})(\d{0,})/gi,
					'$1.$2.$3.$4.$5.$6.$7.$8'
				)
				.replace(/\.*$/, '')
				.substring(0, 54);

			this.form.controls.barCode.setValue(a);
		} else {
			let a = p.replace(/\D/g, '');
			a = a
				.replace(
					/(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,11})(\d{0,1})(\d{0,})/gi,
					'$1-$2 $3-$4 $5-$6 $7-$8 $9'
				)
				.replace(/( |-)*$/, '')
				.substring(0, 55);

			this.form.controls.barCode.setValue(a);
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/bar-code/bar-code.component.ts